class MealSelectedUIModel {
  constructor({
    mealCode = '',
    mealName = '',
    mealSegmentCode = '',
    mealDescription = null,
  }) {
    this.mealCode = mealCode;
    this.mealName = mealName;
    this.mealSegmentCode = mealSegmentCode;
    this.mealDescription = mealDescription;
  }
}

export default MealSelectedUIModel;
